import { useApplicationConfig } from '@bonusly/application';

import { buildURL } from '../util/url';

export const useMonarchURL = (...paths: (string | number)[]) => {
	const base = useApplicationConfig('monarchOrigin');
	return buildURL(base)(...paths);
};
